export enum GoogleAnalyticsEvent {
  FireTags = 'fireTags',
  Login = 'login',
  AddToCart = 'add_to_cart',
  BeginCheckout = 'begin_checkout',
  Purchase = 'purchase',
  RemoveFromCart = 'remove_from_cart',
  SelectItem = 'select_item',
  SelectSku = 'select_sku',
  ViewCart = 'view_cart',
  ViewItem = 'view_item',
  ViewItemList = 'view_item_list',
  CustomEvent = 'customEvent',
  TrackEvent = 'trackEvent',
  RegistrationStart = 'registration_start',
  RegistrationComplete = 'registration_complete',
  RegistrationAttempt = 'registration_attempt',
  RegistrationStep = 'registration_step',
  RegistrationStepError = 'registration_step_error',
  RegistrationError = 'registration_error',
  AccountNumberHelp = 'account_number_help',
  EmailValidated = 'email_validated',
  EmailAlreadyValidated = 'email_already_validated',
  CdpWarrantyInfo = 'cdp_warranty_info',
  CdpColorFamily = 'cdp_color_family',
  CdpColorCollection = 'cdp_color_collection',
  CdpLaunchVisualizer = 'cdp_launch_visualizer',
  CdpColorConsultation = 'cdp_color_consultation',
  CdpFindStore = 'cdp_find_store',
  CdpDetailView = 'cdp_detail_view',
  CdpColourShade = 'cdp_colour_shade',
  CdpCoordinatingColour = 'cdp_coordinating_colour',
  CdpRemoveColorFromFavorites = 'cdp_remove_color_from_favorites',
  CdpAltImageClick = 'cdp_alt_image_click',
  CdpAddColorToFavorites = 'cdp_add_color_to_favorites',
}
